import request from '@/utils/request'

export function fetchList(data) {
  return request({
    url: '/CommissionSchemaCategory/List',
    method: 'post',
    data,
  })
}

export function getItem(id) {
  return request({
    url: '/CommissionSchemaCategory/Get',
    method: 'post',
    data: { id },
  })
}

export function createItem(data) {
  // console.log('createItem', data)

  return request({
    url: '/CommissionSchemaCategory/Create',
    method: 'post',
    data,
  })
}

export function updateItem(data) {
  // console.log('updateItem', data)

  return request({
    url: '/CommissionSchemaCategory/Update',
    method: 'post',
    data,
  })
}

export function deleteItem(data) {
  return request({
    url: '/CommissionSchemaCategory/Delete',
    method: 'delete',
    data,
  })
}
